import { Box, styled, Typography } from '@mui/material';
import { SpinnerCircularFixed } from 'spinners-react';

type VariantType = 'light' | 'dark';
type Props = {
  text?: string;
  variant?: VariantType;
};

const Container = styled(Box)<{ variant?: VariantType }>(({ theme, variant }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  position: 'absolute',
  zIndex: 1000,
  backgroundColor: variant === 'light' ? theme.palette.background.default : 'black',
}));

export default function PageLoader({ text, variant = 'light' }: Props) {
  const isDark = variant === 'dark';

  return (
    <Container variant={variant}>
      <SpinnerCircularFixed
        size={88}
        thickness={100}
        speed={100}
        color={isDark ? 'white' : 'black'}
        secondaryColor={isDark ? '#2A2A2A' : '#EFEFEF'}
      />
      <Typography
        variant="body1"
        fontWeight={500}
        fontSize={20}
        lineHeight="24px"
        textAlign="center"
        color={isDark ? 'white' : 'black'}
        sx={{ mt: 1 }}
      >
        {text}
      </Typography>
    </Container>
  );
}
